export default function QuestionPalette({
  total,
  current,
  answers,
  review,
  onJump,
}) {
  return (
    <div className="w-64 bg-white border-l p-4">
      <h3 className="text-sm font-semibold mb-3">Questions</h3>

      <div className="grid grid-cols-5 gap-2">
        {Array.from({ length: total }).map((_, i) => {
          const status = review[i]
            ? "border-yellow-400"
            : answers[i]
            ? "bg-green-500 text-white"
            : "bg-gray-200";

          return (
            <button
              key={i}
              onClick={() => onJump(i)}
              className={`h-9 rounded text-sm font-medium ${status}
                ${i === current ? "ring-2 ring-blue-600" : ""}`}
            >
              {i + 1}
            </button>
          );
        })}
      </div>

      <div className="mt-4 text-xs space-y-1">
        <p>🟩 Answered</p>
        <p>🟨 Marked for Review</p>
        <p>⬜ Not Visited</p>
      </div>
    </div>
  );
}
